import { assets } from '@/ui/assets'
import { ExternalLink } from '@/ui/atoms/link/Link'
import { cn } from '@/ui/utils/style'

export type IntegratorType = 'nansen' | 'bitget' | 'imtoken'

interface IntegratorConfig {
  logo: string
  name: string
  link: string
  borderColor: string
  bgColor: string
}

const integratorConfigs: Record<IntegratorType, IntegratorConfig> = {
  nansen: {
    logo: assets.integrators.nansen,
    name: 'Nansen',
    link: 'https://nansen.ai',
    borderColor: cn('border-[#00ffa7]/30'),
    bgColor: cn('bg-[#00ffa7]/10'),
  },
  bitget: {
    logo: assets.integrators.bitget,
    name: 'Bitget',
    link: 'https://www.bitget.com',
    borderColor: cn('border-[#00f0ff]/30'),
    bgColor: cn('bg-[#00f0ff]/10'),
  },
  imtoken: {
    logo: assets.integrators.imtoken,
    name: 'imToken',
    link: 'https://token.im',
    borderColor: cn('border-[#0CC5FF]/30'),
    bgColor: cn('bg-[#0CC5FF]/10'),
  },
}

export interface RefBadgeProps {
  integrator: IntegratorType
}

export function RefBadge({ integrator }: RefBadgeProps) {
  const config = integratorConfigs[integrator]

  return (
    <div className={`flex items-center gap-2.5 rounded border ${config.borderColor} ${config.bgColor} px-3 py-2`}>
      <img src={config.logo} alt={config.name} className="size-6" />
      <span className="typography-label-3 text-primary">
        <ExternalLink to={config.link} variant="secondary">
          {config.name}
        </ExternalLink>{' '}
        referral code applied.
      </span>
    </div>
  )
}
